import React from 'react';
import { RiSearch2Line } from "react-icons/ri";

const SearchFilter = ({
  searchTerm,
  onSearchChange,
  placeholder = "Search across all columns...",
  className = '',
  inputClassName = 'input input-sm h-10 pl-10 pr-4 w-80 input-bordered focus:outline-none focus:ring-2 focus:ring-blue-500 uppercase',
  debounceMs = 300,
  disabled = false,
  isLoading = false
}) => {
  return (
    <div className={`relative flex items-center ${className}`}>
      {isLoading ? (
        <div className="absolute left-3 z-10">
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500"></div>
        </div>
      ) : (
        <RiSearch2Line className={`absolute left-3 z-10 ${disabled ? 'text-gray-300' : 'text-gray-400'}`} />
      )}
      <input
        type="search"
        className={`${inputClassName} ${disabled ? 'cursor-not-allowed opacity-50 bg-gray-100' : ''}`}
        placeholder={placeholder}
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        disabled={disabled}
      />
    </div>
  );
};

export default SearchFilter;